import { baseApi } from './baseApi';
import type { ApiResponse, Settings } from '../../types/api';

interface UpdateSettingsRequest {
  usdRate?: number;
  referralPercent?: number;
  payments?: Settings['payments'];
  welcomeImageUrl?: string;
}

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<ApiResponse<{ settings: Settings }>, void>({
      query: () => ({
        url: '/settings',
        method: 'GET',
      }),
      providesTags: ['Settings'],
    }),
    updateSettings: builder.mutation<ApiResponse<{ settings: Settings; message: string }>, UpdateSettingsRequest>({
      query: (data) => ({
        url: '/settings',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingsApi;
